/*
 * @LastEditors: caobopan
 * @LastEditTime: 2022-12-16 09:48:57
 * @Description: feature页面
 * @FilePath: /starmaker-starvr-officialnew/src/pages/home/components/steam/index.js
 */


import { steam } from './static'
import './index.scss';

const Steam = () => {
  const toNext = (link) => {
    if (link) {
      window.open(link, "_blank")
    }
  }
  return (
    <div className="Steam absolute left-28 bottom-4">
      <div>
        {steam && steam.map((item) =>
          <div key={item.title} className="item-box cursor-pointer h-12 mb-4" onClick={() => toNext(item.link)}>
            <div className='steam-img-box'><img className='w-12 h-12' src={item.img} alt='' /></div>
            <div className='content pl-14'>
              <div className='desc font-sans d9'>{item.desc}</div>
              <div className='date font-sans e3'>{item.title}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Steam;
